import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from 'hooks/redux';

import { aiChatSelectors } from 'app-components/flux/ai-chat';
import { preferencesV2Selectors, usePreferenceV2 } from 'app-components/flux/preferences-v2';
import { isDemoMode } from 'app-components/utils/core';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';

import ChatLauncher, { ChatDockProvider, useChatDock } from 'components/ChatLauncher';
import ErrorBoundary from 'components/ErrorBoundary';
import Header from 'containers/App/Header';
import { navBarWidth } from 'containers/App/Header/commonNavStyles';
import DemoModeBar from 'containers/DemoModeBar';
import PrivacyModeBar from 'containers/PrivacyModeBar';
import Services from 'containers/Services';
import UserGuide from 'containers/UserGuide';

const LayoutDatasetEntitledContent = () => {
  const demoMode = isDemoMode();
  const privacyMode = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'privacyMode'));
  const [sPrivacyMode] = usePreferenceV2('sPrivacyMode');
  const isPrivacyMode = privacyMode && sPrivacyMode;
  const { isDocked, drawerWidth } = useChatDock();
  const isChatOpen = useAppSelector(aiChatSelectors.isChatOpen);
  const hideNavButtons = useAppSelector(
    (state) => preferencesV2Selectors.getPreferenceValue(state, 'gsfScreen', 'completed_gsf') !== 'completed_gsf',
  );

  return (
    <Box id='app-router-root' height='100vh' display='flex' flexDirection='column'>
      <Collapse in={Boolean(demoMode)} style={{ minHeight: 'unset' }}>
        <DemoModeBar />
      </Collapse>

      <Collapse in={isPrivacyMode} style={{ minHeight: 'unset' }}>
        <PrivacyModeBar />
      </Collapse>

      <Box position='relative' flexGrow={1} overflow='auto'>
        <Header />
        <Box
          id='feature-root'
          data-testid='feature-root'
          ml={hideNavButtons ? 0 : `${navBarWidth}px`}
          mr={isDocked && isChatOpen ? `${drawerWidth}px` : 0}
          position='relative'
          display='flex'
          flexDirection='column'
          height='100%'
          overflow='auto'
          sx={{
            transition: (theme) =>
              theme.transitions.create('margin-right', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              }),
          }}
        >
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Box>

        <Services />

        <ErrorBoundary>
          <ChatLauncher />
        </ErrorBoundary>

        <ErrorBoundary>
          <UserGuide />
        </ErrorBoundary>
      </Box>
    </Box>
  );
};

const LayoutDatasetEntitled = () => {
  return (
    <ChatDockProvider>
      <LayoutDatasetEntitledContent />
    </ChatDockProvider>
  );
};

export default LayoutDatasetEntitled;
